// @flow

import { setStepInputsRequire } from './set-step-inputs-require'

export const switchToNextStep = (step: number) => {
  setStepInputsRequire(false, step)
  setStepInputsRequire(true, step + 1)

  document.querySelector(`[data-step="${step}"]`)?.classList.remove('active')
  document.querySelector(`[data-step="${step + 1}"]`)?.classList.add('active')

  document.querySelector(`[data-crumb="${step}"]`)?.classList.remove('active')
  document.querySelector(`[data-crumb="${step + 1}"]`)?.classList.add('active')

  const checkboxWrapper = document.querySelector('.checkbox-wrap')
  const submitWrapper = document.querySelector('.enroll__btn-wrapper')
  const submitBtn = submitWrapper?.querySelector('input')

  if (checkboxWrapper) {
    checkboxWrapper.classList.remove('hidden')
    const checkbox = checkboxWrapper.querySelector('input')

    if (checkbox instanceof HTMLInputElement) {
      checkbox.required = true
    }
  }

  if (submitBtn) {
    submitBtn.value = 'Подтвердить'
  }
}
